// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ba011627","977":"3d24d325"}[chunkId] + ".chunk.js";
};